import Alert from '@mui/material/Alert';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

function ErrorPage() {
    return (
        <Container data-cy="error-page">
            <Alert
                variant="outlined"
                severity="error"
                sx={{
                    '& .MuiAlert-icon': {
                        fontSize: 36,
                        marginTop: '0.65rem',
                    },
                    marginTop: '2.5rem',
                }}
            >
                <Typography
                    sx={{
                        fontSize: 28,
                        paddingTop: '0.4rem',
                        color: 'rgb(88, 20, 20)',
                    }}
                >
                    Something is not working properly. We will fix the problem as soon as possible. You can try
                    refreshing the page or coming back later. If you continue to see this error, please contact the
                    Service Desk at <b>(763) 406-3411</b>.
                </Typography>
            </Alert>
        </Container>
    );
}

export default ErrorPage;
